// extracted by mini-css-extract-plugin
export default {"socialDropdownWrapper":"_ec1675f2","moreDotsIcon":"_ac82d713 _ff04910a","itemsContainer":"_f2af12a0"};